<template>
  <v-card flat class="secondary vetalfa-view">
    <div ref="screenHeader" class="vetalfa-global-header secondary">
      <vetalfa-small-header
        showBreadCrumbAndTitle
        :title="headerTitle"
        :hasSlotOption="true"
        :breadcrumb="headerTitle"
      >
        <items-filter
          class="ma-0 pa-0 vetalfa-pointer"
          v-if="!loading && showFilters"
          :showFilters="showFilters"
          v-on:applyFilters="applyFilters"
        ></items-filter>
        <template v-slot:headerSearch>
          <v-row justify="center" :class="`primary pa-0 pt-0 pb-4 ma-0`">
            <v-row class="vetalfa-max-width pa-0 ma-0 px-4">
              <v-col
                class="ma-0 pa-0"
                :cols="
                  !!category &&
                  !category.hideBrandSelection &&
                  !hideBrand &&
                  !loading
                    ? 8
                    : 12
                "
                :sm="
                  !!category &&
                  !category.hideBrandSelection &&
                  !hideBrand &&
                  !loading
                    ? 11
                    : 12
                "
              >
                <v-text-field
                  dense
                  outlined
                  clearable
                  :value="search"
                  :disabled="loading"
                  :loading="loading"
                  v-model="search"
                  class="items-search-bar"
                  :placeholder="searchPlaceholder"
                  ref="searchField"
                  :style="{ borderRadius: '10px' }"
                  hide-details
                  type="text"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" class="mr-0">
                      {{ _icon("magnify") }}
                    </v-icon>
                  </template>
                  <template v-if="toggles['ai_search']" v-slot:append-outer>
                    <v-btn
                      @click="searchWithAI('Button')"
                      fab
                      small
                      color="white"
                    >
                      <v-icon color="primary" class="mr-0" size="24">
                        {{ mdiCreation }}
                      </v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                v-if="
                  !!category &&
                  !category.hideBrandSelection &&
                  !hideBrand &&
                  !loading
                "
                class="ma-0 pa-0"
                :cols="4"
                :sm="1"
              >
                <v-row
                  @click="toggleShowProducts()"
                  align="center"
                  justify="end"
                  class="items-filter-products-selector pa-0 ma-0"
                >
                  <span class="items-filter-products-selector-text">{{
                    labels.DRUGS_BRANDS
                  }}</span>
                  <div
                    v-bind:class="
                      displayProducts
                        ? 'items-filter-products-selector-on'
                        : 'items-filter-products-selector-off'
                    "
                    class="ml-1"
                  >
                    <div class="items-filter-products-selector-toggle"></div>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-row>
        </template>
        <template v-slot:headerContent>
          <v-row no-gutters justify="center">
            <v-col cols="12" class="ma-0 pa-0" align-content="center">
              <v-row no-gutters justify="center">
                <chip-filters
                  class="px-2 ml-4 mt-1 vetalfa-max-width"
                  v-if="hasChipFilters && !loading"
                  v-on:applyFilters="applyFilters"
                  v-on:createListOfItems="createListOfItems"
                ></chip-filters>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </vetalfa-small-header>
      <v-row no-gutters justify="center">
        <v-row no-gutters class="vetalfa-max-width">
          <vetalfa-ads
            class="pl-4 pr-2"
            @adsLoaded="setupScreenSizes"
            v-if="!search"
          ></vetalfa-ads>
        </v-row>
      </v-row>
    </div>
    <div
      ref="screenContent"
      :style="{ paddingTop: _isMobile() ? '150px' : '240px' }"
    >
      <v-skeleton-loader
        v-if="!!loading"
        class="ma-0 pa-0"
        :type="skeletonType"
      ></v-skeleton-loader>
      <div v-if="!loading && scrollHeight != 0" class="pl-2">
        <v-row
          v-if="!itemsList || !itemsList.length"
          justify="center"
          class="ma-0 pa-0 mt-5 pt-8"
        >
          <v-col class="ma-0 pa-0" cols="12">
            <v-row class="ma-0 pa-0" justify="center">
              <v-img
                position="center"
                height="60px"
                class="ma-0 pa-0"
                :src="
                  isFavoritesMode
                    ? images.NO_FAVORITES
                    : isGlobalSearchWithoutInput
                    ? images.SEARCH
                    : images.SEARCH
                "
                :lazy-src="
                  isFavoritesMode
                    ? images.NO_FAVORITES
                    : isGlobalSearchWithoutInput
                    ? images.SEARCH
                    : images.SEARCH
                "
                max-width="300"
                contain
              ></v-img>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0 px-5" cols="12">
            <v-row no-gutters justify="center">
              <p
                class="text-center ma-0 pa-0 mt-5 subtitle-2 grey--text"
                style="max-width: 400px"
              >
                {{
                  _getLabel(
                    isFavoritesMode
                      ? "NO_FAVORITES"
                      : isGlobalSearchWithoutInput
                      ? "NO_SEARCH"
                      : "NO_CONTENT"
                  )
                }}
              </p>
            </v-row>
          </v-col>

          <v-col cols="12" class="ma-0 pa-0">
            <v-row
              no-gutters
              justify="center"
              v-if="search && toggles['ai_search']"
              class="mt-8 mb-2"
            >
              <v-alert
                outlined
                border="left"
                rounded
                color="primary"
                class="vetalfa-pointer mx-4 my-0"
                @click="searchWithAI('Alert')"
                dense
                style="background-color: white !important"
              >
                <v-row align="start" no-gutters>
                  <v-col class="shrink ma-0 pa-0 mr-4">
                    <v-chip small color="primary">Novidade</v-chip>
                  </v-col>
                  <v-col class="grow ma-0 pa-0 subtitle-2 pr-2">
                    Converse com a nossa IA sobre Medicina Veterinária.
                  </v-col>
                  <v-col class="shrink ma-0 pa-0">
                    <v-icon x-small color="primary">
                      {{ icons.mdiChevronRight }}
                    </v-icon>
                  </v-col>
                </v-row>
              </v-alert>
            </v-row>
          </v-col>
          <v-col
            v-if="!isPathParameterMode || $route.params.mode === 'drugs'"
            class="ma-0 pa-0 mt-5"
            cols="12"
          >
            <v-row class="ma-0 pa-0" justify="center">
              <v-btn
                class="text-none mb-2"
                color="primary"
                rounded
                elevation="5"
                @click="searchOnVetAlfa()"
                >{{ _getLabel("SEARCH_ON_VET_ALFA") }}
              </v-btn>
            </v-row>
          </v-col>

          <search-not-found
            v-else-if="!isGlobalSearchWithoutInput"
            class="mt-8"
          ></search-not-found>
        </v-row>

        <v-virtual-scroll
          v-if="itemsList.length"
          :items="itemsList"
          :item-height="itemsHeight"
          :bench="0"
          :height="scrollHeight"
          id="items-virtual-scroll"
        >
          <template v-slot="{ item, index }">
            <div>
              <div v-if="item.name">
                <v-row
                  v-if="isPhotosCategory"
                  @click="openSection(item)"
                  class="ma-0 pa-0 px-2"
                  v-bind:style="itemRow"
                  align="center"
                >
                  <v-card height="140" width="100%" elevation="2">
                    <v-row class="ma-0 pa-0 vetalfa-row" align="center">
                      <v-img
                        max-width="100px"
                        height="100px"
                        position="center"
                        :src="item.photo"
                        contain
                        style="border-radius: 5px"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              width="2"
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-col
                        :cols="$vuetify.breakpoint.xsOnly ? 7 : 9"
                        class="ma-0 pa-0 pr-2 pl-4"
                        style="height: 100%"
                      >
                        <p
                          class="ma-0 pa-0 vetalfa-dialog-title text-left mt-2 pt-2"
                        >
                          {{ item.name }}
                        </p>
                        <p
                          class="ma-0 pa-0 vetalfa-card-text primary--text text-left"
                        >
                          {{ item.brand }}
                        </p>
                        <p
                          class="ma-0 pa-0 vetalfa-card-text-disabled text-left mt-4"
                          v-bind:style="`display:-webkit-box;-webkit-line-clamp:${
                            !$vuetify.breakpoint.xsOnly
                              ? '2'
                              : item.name.length > 30
                              ? '1'
                              : '3'
                          };-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;`"
                        >
                          {{ item.drugs ? ` ${item.drugs.join("; ")}` : "" }}
                        </p>
                        <v-icon
                          class="items-arrow-button"
                          x-small
                          color="#747678"
                          >{{ icons.mdiChevronRight }}</v-icon
                        >
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
                <v-row
                  v-else-if="item.name"
                  @click="openSection(item)"
                  class="ma-0"
                  v-bind:style="itemRow"
                  align="center"
                >
                  <v-card
                    outlined
                    :height="`53px`"
                    style="
                      width: 100%;
                      border: 1px solid #eeeeee !important;
                      border-radius: 10px;
                    "
                    class="ma-0 pa-0 white mx-2 px-2"
                  >
                    <v-row class="ma-0 pa-0 vetalfa-row" align="center">
                      <v-col :cols="11" class="ma-0 pa-0">
                        <v-row class="ma-0 pa-0" align="center">
                          <p
                            v-bind:class="
                              (item.type
                                ? 'items-products-title'
                                : 'items-title') +
                              (!!isPathParameterMode
                                ? ' items-two-lines-clamp'
                                : '')
                            "
                            v-html="item.name"
                            class="ma-0"
                          ></p>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                          <p
                            v-if="!!isPathParameterMode || !!item.description"
                            class="items-description-label text-center mt-1 ma-0 pa-0"
                          >
                            {{ getDescription(item) }}
                          </p>
                          <p
                            v-else-if="item.type"
                            class="items-products-label-box text-center mt-1 ma-0 pa-0 px-1"
                          >
                            vet
                          </p>
                        </v-row>
                      </v-col>
                      <v-col :cols="1" class="ma-0 pa-0">
                        <v-row
                          v-if="
                            !isPremium &&
                            (item.premium ||
                              ($route.params.topic && !item.freeTrial))
                          "
                          justify="end"
                          class="ma-0 pa-0 pl-2 pr-0"
                        >
                          <v-icon small color="primary">
                            {{ icons.mdiLockOutline }}
                          </v-icon>
                        </v-row>
                        <v-row
                          @click.stop="postFavoritesAsync(item)"
                          v-else-if="isFavoritesMode"
                          justify="end"
                          class="ma-0 pa-0 pr-1"
                        >
                          <v-icon small color="primary">{{
                            icons.mdiBookmark
                          }}</v-icon>
                        </v-row>
                        <v-row v-else justify="end" class="ma-0 pa-0 pr-1">
                          <v-icon x-small color="#747678">{{
                            icons.mdiChevronRight
                          }}</v-icon>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
              </div>
              <v-row
                v-else-if="item.blank"
                v-bind:id="`blank-${index}`"
                align="center"
                justify="start"
                class="ma-0 pa-0"
                v-bind:style="`height: ${itemsHeight}px;`"
              >
              </v-row>
              <v-row
                v-else
                v-bind:id="`letter-${item.letter}`"
                align="end"
                class="ma-0 pa-0"
                v-bind:style="`height: ${itemsHeight}px;`"
              >
                <v-row
                  align="end"
                  justify="start"
                  class="items-row-letter ma-0 pa-0 pl-2"
                >
                  <v-col cols="12" class="ma-0 pa-0">
                    <p class="pa-0 ma-0">{{ item.letter }}</p>
                  </v-col>
                </v-row>
              </v-row>
            </div>
          </template>
        </v-virtual-scroll>
        <v-row no-gutters v-if="!itemsList || !itemsList.length">
          <v-col
            cols="12"
            class="ma-0 pa-0"
            no-gutters
            style="height: 200px"
          ></v-col>
        </v-row>
      </div>
    </div>
  </v-card>
</template>

<style>
.v-skeleton-loader__heading {
  margin: 8px 0px 8px 12px !important;
  height: 52px !important;
  width: 92% !important;
}
.v-skeleton-loader__chip {
  border-radius: 8px !important;
  height: 25px !important;
  width: 186px !important;
  margin-top: 24px !important;
  margin-left: 12px !important;
}
.items-two-lines-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 3px;
}
.items-back-button {
  position: absolute;
  left: 15px;
  top: calc(35px + env(safe-area-inset-top));
  cursor: pointer;
}
.items-arrow-button {
  position: absolute !important;
  right: 8px;
  top: 60px;
}
.items-title {
  color: #393a3a;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16px;
  font-weight: normal;
}
.items-products-title {
  color: #393a3a;
  font-size: 14px;
  font-style: italic;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
}
.items-description-label {
  font-size: 10px;
  line-height: 14px;
  color: rgb(57, 58, 58, 0.52);
}
.items-products-label-box {
  box-sizing: border-box;
  border: 1px solid rgb(0, 114, 138, 0.14);
  border-radius: 10px;
  background-color: rgb(0, 114, 138, 0.14);
  font-size: 10px;
  line-height: 10px;
  color: rgb(57, 58, 58, 0.92);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.35);
}
.theme--light.v-label {
  font-size: 14px !important;
}
.items-top-bar {
  border-radius: 0px !important;
  background: transparent;
  width: 100%;
  height: 130px;
}
.items-row-letter {
  background-color: transparent;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  color: #193153;
}

.items-filter-products-selector-text {
  color: white;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
}
.items-filter-products-selector-toggle {
  height: 12px;
  width: 12px;
  background-color: #193153;
  border-radius: 31.5px;
  border: 1px solid #ffffff;
}
.items-filter-products-selector-on {
  box-sizing: border-box;
  height: 17.45px;
  width: 35px;
  border: 1px solid #ffffff;
  background-color: #ffffff;
  border-radius: 31.5px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-end;
  align-content: center;
  align-items: center;
  display: -webkit-flex;
  -webkit-align-items: center;
  padding-right: 2px;
  padding-bottom: 0.5px;
}
.items-filter-products-selector-off {
  box-sizing: border-box;
  height: 17.45px;
  width: 35px;
  border: 1px solid #ffffff;
  background-color: transparent;
  border-radius: 31.5px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  display: -webkit-flex;
  -webkit-align-items: center;
  padding-left: 2px;
  padding-bottom: 0.5px;
}
.items-filter-products-selector {
  cursor: pointer;
  height: 40px;
}
.items-search-bar {
  background-color: transparent;
}
.items-search-bar .v-input__control {
  background-color: white;
}
.items-search-bar .v-input__append-outer {
  background-color: transparent;
  padding: 0px;
  margin: 0px 0px 0px 16px !important;
}
</style>

<script>
import images from "@/constants/images.js";
import labels from "@/constants/labels.js";
import parameters from "@/constants/parameters.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  mdiChevronRight,
  mdiClose,
  mdiChevronLeft,
  mdiLockOpenVariantOutline,
  mdiLockOutline,
  mdiBookmark,
  mdiCreation,
} from "@mdi/js";
import ItemsFilter from "@/components/ItemsFilter.vue";
import categories from "@/constants/categories.js";
import ChipFilters from "@/components/ChipFilters.vue";
import SearchNotFound from "@/components/complete/SearchNotFound.vue";
export default {
  name: "Items",
  watch: {
    search() {
      if (this.hasMounted) {
        this.filterSummary();
      }
    },
    triggerFavoritesChange() {
      this.loading = true;
      this.classes = {
        "A-Z": {
          items: [
            ...this.preferences.sort((a, b) =>
              this._removeAccents(a.name) > this._removeAccents(b.name) ? 1 : -1
            ),
          ],
        },
      };
      this.filterSummary();
      this.loading = false;
    },
  },
  methods: {
    ...mapActions("drugs", [
      "openItemOrProduct",
      "openCategory",
      "clearFilters",
    ]),
    ...mapActions("preferences", [
      "getPreferencesByMode",
      "postFavorites",
      "getAndUpdateRecentSearches",
    ]),
    ...mapActions("topics", ["openTopic", "openTopicItem"]),
    ...mapActions("calculators", ["openCalculatorById", "openCalculators"]),
    ...mapActions("general", [
      "openExternalUrl",
      "logEvent",
      "routePathRedirect",
      "popLastCrumbItem",
    ]),
    ...mapMutations("drugs", [
      "setFeatures",
      "setDrugTab",
      "setShowProducts",
      "setVirtualScroll",
      "setSearchValue",
      "setItemsList",
      "setPresentationList",
      "setClassesList",
      "setBrandList",
      "setActivePrinciplesList",
      "setPetAges",
      "setPetSizes",
      "setPetBreeds",
      "setBrandLines",
    ]),
    searchWithAI(location) {
      this.logEvent("openConversationsFromItems" + location);
      this.routePathRedirect({ path: "/ai-conversations/new" });
    },
    postFavoritesAsync(favorite) {
      this.postFavorites({
        favorite,
      });
    },
    searchOnVetAlfa() {
      this.logEvent("openGlobalSearchesFromItems");
      this.clearFilters();
      this.popLastCrumbItem();
      this.$router.replace({ path: "/items/searches" }).then(() => {
        this.handleMode();
      });
    },
    getDescription(item) {
      if (item.description) return item.description;
      return item.topic
        ? item.topic
        : categories[item.category - 1].portugueseName;
    },
    createListOfItems() {
      if (this.drugsSummary && this.productsSummary) {
        if (this.category.orderByClasses) {
          this.filterItemsByClasses();
        } else {
          this.filterItemsByLetter();
        }
        this.filterSummary();
      }
      this.setupScreenSizes();
    },
    applyFilters() {
      this.displayProducts = true;
      this.filterSummary();
    },
    openSection(item) {
      this.getAndUpdateRecentSearches(item);
      if (this.category.id == 7 || item.category == 7) {
        this.openCalculatorById({ id: item.id });
      } else if (
        (this.$route.params.topic || !!item.topic) &&
        !["foods", "oral_hygiene", "supplements"].includes(
          this.$route.params.topic
        )
      ) {
        this.openTopicItem({ itemId: item.id, redirectMode: true });
      } else {
        this.openItemOrProduct(item);
      }
    },
    toggleShowProducts() {
      this.displayProducts = !this.displayProducts;
      this.filterSummary();
    },
    hasValidFilters(item) {
      if (this.$route.params.mode === "drugs") {
        const validCategory =
          !this.categoryFilter ||
          this.categoryFilter == parseInt(item.category);
        const validClass =
          !this.classesFilter || item.classes.includes(this.classesFilter);
        const validSystem =
          !this.systemFilter ||
          this.systemFilter.classes.some((value) =>
            item.classes.includes(value)
          );
        return validCategory && validClass && validSystem;
      } else if (this.$route.params.topic === "foods") {
        return (
          (!this.categoryFilter ||
            this.categoryFilter == parseInt(item.category)) &&
          this.validateFilters(item)
        );
      }
      return this.validateFilters(item);
    },
    validateFilters(item) {
      const validPresentation =
        this.presentationFilter === undefined ||
        item.presentationList.includes(
          this.presentationList[this.presentationFilter]
        );
      const classToValidate =
        typeof this.classesFilter == "number"
          ? this.classesList[this.classesFilter]
          : this.classesFilter;

      const validClass =
        this.classesFilter === undefined ||
        this.classesFilter === null ||
        item.classes.includes(classToValidate.trim());
      const validBrand =
        this.brandFilter === undefined ||
        this.brandFilter.length == 0 ||
        this.brandFilter.includes(item.brand);
      const validDrugs =
        this.activePrinciplesFilter === undefined ||
        this.activePrinciplesFilter.length == 0 ||
        this._doesArrayContainAllElementsOfAnother(
          item.drugs,
          this.activePrinciplesFilter
        );

      const validAges =
        this.petAgesFilter === undefined ||
        this.petAgesFilter.length == 0 ||
        this.petAgesFilter.every((age) => item.petAges.includes(age));
      const validSizes =
        this.petSizesFilter === undefined ||
        this.petSizesFilter.length == 0 ||
        this.petSizesFilter.every((size) => item.petSizes.includes(size));
      const validBreeds =
        this.petBreedsFilter === undefined ||
        this.petBreedsFilter.length == 0 ||
        this.petBreedsFilter.every((breed) => item.petBreeds.includes(breed));
      const validFeatures =
        this.featuresFilter === undefined ||
        this.featuresFilter.length == 0 ||
        this.featuresFilter.every((feature) => item.features.includes(feature));
      const validBrandLine =
        this.brandLinesFilter === undefined ||
        this.brandLinesFilter === null ||
        item.brandLines.includes(this.lines[this.brandLinesFilter]);
      return (
        (!this.dogFilter || item.dogs) &&
        (!this.catFilter || item.cats) &&
        validPresentation &&
        validClass &&
        validBrand &&
        validDrugs &&
        validAges &&
        validSizes &&
        validBreeds &&
        validFeatures &&
        validBrandLine
      );
    },
    filterSummary() {
      const filter =
        this._removeAccents(this.search.trim().toLowerCase()) || "";
      this.setupScreenSizes();
      this.displayProducts = !!filter || this.displayProducts;
      let firstLetter = "";
      this.filtered = [];
      let hasFreeTrial = false;
      let hasUpdates = false;
      const synonyms = this.synonyms.filter((synonym) => {
        return this._removeAccents(synonym[0])
          .toLowerCase()
          .includes(filter || null);
      });
      for (let key in this.classes) {
        this.classes[key].items.forEach((item) => {
          if (
            !!item.disabled ||
            (!!this.isPhotosCategory && !item.type) ||
            (!this.displayProducts && !!item.type) ||
            !this.hasValidFilters(item)
          ) {
            return;
          }

          const name = this._removeAccents(item.name.toLowerCase());
          const synonym = this.findItemFromSynonym(filter, name, synonyms);
          if (!!filter && !name.includes(filter) && !synonym) {
            return;
          }
          if (!!item.freeTrial && !this.isPremium) {
            hasFreeTrial = true;
            this.filtered = [item].concat(this.filtered);
            return;
          } else if (!!item.isNew && !!this.isPremium) {
            hasUpdates = true;
            this.filtered = [item].concat(this.filtered);
            return;
          }

          const itemFirstLetter = !this.category.orderByClasses
            ? this._removeAccents(this._getUpperCaseFirstLetter(item.name))
            : this._removeAccents(key);

          if (firstLetter !== itemFirstLetter && !this.isPhotosCategory) {
            firstLetter = itemFirstLetter;
            this.filtered.push({
              letter: !this.category.orderByClasses ? itemFirstLetter : key,
              id: firstLetter,
            });
          }
          this.filtered.push({ ...item, name: item.name + synonym });
        });
      }
      if (hasFreeTrial || hasUpdates) {
        this.filtered = [
          { letter: hasFreeTrial ? "Descubra Agora" : "Novidades", id: "da" },
        ].concat(this.filtered);
      }
      this.addBlankEntryToHandleScroll();
      this.setupScreenSizes();
      this.setItemsList(
        this.isGlobalSearchWithoutInput ? this.recentSearches : this.filtered
      );
    },
    setupScreenSizes() {
      let paddingTop = this.isPhotosCategory ? -12 : 30;
      this._setupScreenSizes(this, paddingTop);
      this.$nextTick(() => {
        this.manageVirtualScroll();
      });
    },
    addBlankEntryToHandleScroll() {
      if (this.filtered.length) {
        this.filtered.push({ blank: true });
        this.filtered.push({ blank: true });
      }
    },
    findItemFromSynonym(search, name, synonyms) {
      let itemFound = "";
      synonyms.forEach((synonym) => {
        if (
          this._removeAccents(synonym[0])
            .toLowerCase()
            .includes(search || null) &&
          name.trim() == synonym[1]
        ) {
          itemFound = ` (${synonym[0]})`;
        }
      });
      return itemFound;
    },
    manageVirtualScroll() {
      let el = document.getElementById("items-virtual-scroll");
      if (el == null) {
        setTimeout(this.manageVirtualScroll, 10);
        return;
      }
      if (el.scrollTop == 0) {
        el.scrollTop = this.getVirtualScroll;
      }
      if (el.scrollHeight - el.clientHeight - 1 < el.scrollTop) {
        el.scrollTop = el.scrollHeight - el.clientHeight - 1;
      }
      this.setVirtualScroll(el.scrollTop);
      el.addEventListener("scroll", this.manageVirtualScroll);
    },
    filterItemsByLetter() {
      let summary = [];
      let filterClasses = [],
        presentationList = [],
        brandList = [],
        activePrinciples = [],
        petSizes = [],
        petAges = [],
        petBreeds = [],
        features = [],
        brandLines = {};
      this.drugsSummary[this.category.collection].forEach((drug) => {
        filterClasses = filterClasses.concat(
          drug.classes || drug.categories || []
        );
        let itemToAdd = {
          name: drug.name,
          id: drug.id,
          disabled: drug.disabled,
          classes: drug.classes || drug.categories || [],
          freeTrial: drug.freeTrial || undefined,
          isNew: drug.isNew || undefined,
        };
        if (this.$route.params.topic) {
          itemToAdd["description"] = drug.description || null;
          drug.animals = drug.animals || [];
          itemToAdd["dogs"] = drug.animals.includes(1);
          itemToAdd["cats"] = drug.animals.includes(2);
        }
        summary.push(itemToAdd);
      });
      this.productsSummary[this.categoryProductsCollection].forEach(
        (product) => {
          if (
            product.type != 2 &&
            (this.$route.params.topic !== "foods" ||
              !this.categoryFilter ||
              this.categoryFilter == parseInt(product.category))
          ) {
            let toAddProduct = {
              name: product.name,
              id: product.id,
              type: product.type,
              category: product.category || null,
            };
            filterClasses = filterClasses.concat(product.classes || []);
            toAddProduct["classes"] = product.classes || [];

            if (this.isPhotosCategory) {
              if (
                [6, 12, 13].includes(
                  this.$route.params.topic == "supplements"
                    ? 6
                    : this.category.id
                )
              ) {
                const filterPresentationList = product.presentationList.map(
                  (el) => {
                    return el.replaceAll("|", " | ");
                  }
                );
                presentationList = presentationList.concat(
                  filterPresentationList
                );
                toAddProduct["presentationList"] = filterPresentationList;

                toAddProduct["drugs"] = [];
                product.drugs.forEach((drug) => {
                  if (!drug.hasLink) {
                    const drugName = this._capitalizeAllFirstLetters(
                      drug.name.trim()
                    );
                    activePrinciples.push(drugName);
                    toAddProduct["drugs"].push(drugName);
                  }
                });
              } else {
                toAddProduct["presentationList"] = [product.presentation];
                petSizes = petSizes.concat(product.petSizes);
                petAges = petAges.concat(product.petAges);
                petBreeds = petBreeds.concat(product.petBreeds);
                toAddProduct["petSizes"] = product.petSizes;
                toAddProduct["petAges"] = product.petAges;
                toAddProduct["petBreeds"] = product.petBreeds;
                features = features.concat(product.features);
                toAddProduct["features"] = product.features;
                if (product.presentation) {
                  presentationList.push(product.presentation);
                }
                if (!brandLines[product.brand.trim()]) {
                  brandLines[product.brand.trim()] = [];
                }
                brandLines[product.brand.trim()] = brandLines[
                  product.brand.trim()
                ].concat(product.brandLines);
                toAddProduct["brandLines"] = product.brandLines;
              }
              brandList.push(product.brand.trim());
              toAddProduct["dogs"] = product.dogs;
              toAddProduct["cats"] = product.cats;
              toAddProduct["photo"] = product.photo;
              toAddProduct["brand"] = product.brand.trim();
            }
            summary.push(toAddProduct);
          }
        }
      );
      this.setBrandLines(brandLines);
      this.setFeatures([...new Set(features)].sort());
      this.setPetAges(["Neonato", "Filhote", "Adulto", "Sênior"]);
      this.setPetSizes(["Mini", "Pequeno", "Médio", "Grande", "Gigante"]);
      this.setPetBreeds([...new Set(petBreeds)].sort());
      this.setClassesList([...new Set(filterClasses)].sort());
      this.setPresentationList([...new Set(presentationList)].sort());
      this.setBrandList([...new Set(brandList)].sort());
      this.setActivePrinciplesList(
        [...new Set(activePrinciples)].sort().filter(function (str) {
          return /\S/.test(str);
        })
      );
      this.classes = {
        "A-Z": {
          items: this.isPhotosCategory
            ? this._shuffleDateBased(summary)
            : [
                ...summary.sort((a, b) =>
                  this._removeAccents(a.name) > this._removeAccents(b.name)
                    ? 1
                    : -1
                ),
              ],
        },
      };
    },
    filterItemsByClasses() {
      this.classes = {};
      let miscClassItems = [];
      this.drugsSummary[this.category.collection].forEach((d) => {
        if (this._isPopulatedArray(d.classes)) {
          d.classes.forEach((c) => {
            if (!this.classes[c]) {
              this.classes[c] = { name: c, items: [] };
            }
            this.classes[c].items.push({
              name: d.name,
              id: d.id,
              disabled: d.disabled,
              premium: d.premium,
              category: d.category,
            });
          });
        } else {
          miscClassItems.push({
            name: d.name,
            id: d.id,
            disabled: d.disabled,
            premium: d.premium,
          });
        }
      });
      if (this.productsSummary[this.categoryProductsCollection]) {
        this.productsSummary[this.categoryProductsCollection].forEach((p) => {
          if (p.type != 2) {
            if (this._isPopulatedArray(p.classes)) {
              p.classes.forEach((c) => {
                if (!this.classes[c]) {
                  this.classes[c] = { name: c, items: [] };
                }
                this.classes[c].items.push({
                  name: p.name,
                  id: p.id,
                  type: p.type,
                });
              });
            } else {
              miscClassItems.push({
                name: p.name,
                id: p.id,
                type: p.type,
              });
            }
          }
        });
      }
      this.classes = {
        "Calculadoras de Infusão": this.classes["Calculadoras de Infusão"],
        Fluidoterapia: this.classes["Fluidoterapia"],
        Transfusão: this.classes["Transfusão"],
        ...Object.keys(this.classes)
          .sort()
          .reduce((obj, key) => {
            obj[key] = this.classes[key];
            return obj;
          }, {}),
      };
      this.classes[this.miscClass] = {
        name: this.miscClass,
        items: miscClassItems,
      };
    },
    async handleMode() {
      if (this.isGlobalSearch && this.toggles["algolia"]) {
        this.popLastCrumbItem();
        return this.$router.replace({ path: "/searches" });
      }
      this.modeTries = this.modeTries + 1;
      if (this.modeTries > 3) {
        return;
      }
      this.loading = true;
      await this.getPreferencesByMode({ mode: this.$route.params.mode });
      if (this.preferences) {
        this.search = this.search || this.$route.query.search_query;
        if (this.category.orderByClasses) {
          this.classes = this.preferences;
        } else {
          this.classes = {
            "A-Z": {
              items: [
                ...this.preferences.sort((a, b) =>
                  this._removeAccents(a.name) > this._removeAccents(b.name)
                    ? 1
                    : -1
                ),
              ],
            },
          };
        }
        this.displayProducts =
          this.displayProducts || this.category.hideBrandSelection;
        if (this.$route.params.mode === "searches") {
          this.recentSearches = await this.getAndUpdateRecentSearches();
          if (this.recentSearches.length) {
            this.recentSearches = [
              { letter: this._getLabel("RECENT_SEARCHES") },
              ...this.recentSearches,
            ];
          }
        }
        this.filterSummary();
        this.loading = false;
      } else {
        setTimeout(this.handleMode.bind(this), 2000);
      }
    },
  },
  computed: {
    ...mapGetters("drugs", [
      "lines",
      "drugsSummary",
      "productsSummary",
      "showProducts",
      "getVirtualScroll",
      "hasFilter",
      "searchValue",
      "category",
      "itemsList",
      "catFilter",
      "dogFilter",
      "presentationFilter",
      "presentationList",
      "classesFilter",
      "classesList",
      "brandFilter",
      "activePrinciplesFilter",
      "systemFilter",
      "petAges",
      "petAgesFilter",
      "petSizes",
      "petSizesFilter",
      "petBreeds",
      "petBreedsFilter",
      "featuresFilter",
      "features",
      "brandLines",
      "brandLinesFilter",
      "categoryFilter",
    ]),
    ...mapGetters("topics", ["topic"]),
    ...mapGetters("preferences", ["preferences", "triggerFavoritesChange"]),
    ...mapGetters("general", ["isPremium", "synonyms", "toggles"]),
    isGlobalSearch() {
      return this.$route.params.mode === "searches";
    },
    isGlobalSearchWithoutInput() {
      return this.isGlobalSearch && !this.search;
    },
    isFavoritesMode() {
      return this.$route.params.mode === "favorites";
    },
    searchPlaceholder() {
      if (this.$route.params.mode == "searches") {
        return this._getLabel("SEARCH_WHAT_YOU_WANT");
      }
      return `${this._getLabel("SEARCH_TEXT")} ${this._getLabel("WHERE")} ${(
        this.headerTitle || ""
      )
        .replace("e Vacinas", "")
        .trim()}`;
    },
    hasChipFilters() {
      return (
        this.$route.params.mode == "drugs" ||
        (!!this.$route.params.topic &&
          this.$route.params.topic != "supplements")
      );
    },
    headerTitle() {
      if (this.$route.params.topic) {
        return this.topic ? this.topic.name : null;
      }
      return this.category ? this.category.portugueseName : null;
    },
    hideBrand() {
      return !!this.search || !!this.hasFilter;
    },
    itemsHeight() {
      return this.isPhotosCategory ? 150 : 63;
    },
    isPathParameterMode() {
      return this.$route.params.mode;
    },
    itemRow() {
      return `
          background-color: transparent;
          height: ${this.itemsHeight - 5}px;
          font-size: 16px;
          font-weight: bold;
          color: black;
          cursor: pointer !important;
        `;
    },
    showFilters() {
      return (
        !!this.category &&
        !this.category.orderByClasses &&
        !this.$route.params.mode &&
        (!this.$route.params.topic ||
          !!this.categoryFilter ||
          this.$route.params.topic == "supplements")
      );
    },
    isPhotosCategory() {
      return !!this.category && this.category.orderByPhotos;
    },
    displayProducts: {
      get() {
        return this.showProducts;
      },
      set(val) {
        this.setShowProducts(val);
      },
    },
    search: {
      get() {
        return this.searchValue;
      },
      set(val) {
        this.setSearchValue(val || "");
      },
    },
    categoryProductsCollection() {
      return this.category.id == 1
        ? "products"
        : this.category.productsCollection;
    },
  },
  components: {
    "items-filter": ItemsFilter,
    "chip-filters": ChipFilters,
    "search-not-found": SearchNotFound,
  },
  data() {
    return {
      icons: {
        mdiLockOpenVariantOutline,
        mdiLockOutline,
        mdiBookmark,
        mdiCreation,
        mdiChevronRight,
        mdiClose,
        mdiChevronLeft,
      },
      mdiCreation,
      modeTries: 0,
      images,
      filtered: [],
      labels,
      scrollHeight: 0,
      classes: {},
      miscClass: parameters.DRUGS_MISC_CLASS,
      hasFilterPadding: false,
      loading: false,
      hasMounted: false,
      snackbar: false,
      recentSearches: [],
      skeletonType:
        "chip,heading,heading,chip,heading,heading,heading,heading,chip,heading,heading,heading,heading,heading,chip,heading,heading,heading,heading",
    };
  },
  mounted: async function () {
    this.hasMounted = true;
    this.loading = true;
    if (this.$route.params.mode) {
      this.loading = false;
      return await this.handleMode();
    } else if (this.$route.query.category == 7) {
      await this.openCalculators();
    } else if (this.$route.params.topic) {
      await this.openTopic(this.$route.params.topic);
    } else if (this.$route.query.category) {
      await this.openCategory(this.$route.query.category);
    }
    this.loading = false;
    this.displayProducts = this.category.hideBrandSelection;
    return this.createListOfItems();
  },
  created() {
    this.setDrugTab(parameters.DRUGS_INFO_DEFAULT_TAB);
  },
};
</script>
